import React from "react";
import styles from "./Skeleton.module.css";
import { SkeletonTabs } from "./SkeletonTabs";
import { SkeletonTable } from "./SkeletonTable";

export function SkeletonPage() {
  return (
    <div className={styles.skeletonPage}>
      {/* Skeleton Headline with title and button */}
      <div className={styles.skeletonHeadline}>
        <div className={styles.skeletonTitle} />
        <div className={styles.skeletonButton} />
      </div>

      {/* Skeleton Tabs */}
      <SkeletonTabs />

      {/* Skeleton Table */}
      <SkeletonTable />
    </div>
  );
}
